import { useAppKitAccount } from "@reown/appkit/react";
import { Address } from "viem";
import { useReadContract } from "wagmi";

import { dailySpinChainId, MS_IN_SECOND } from "@/constants/shared";
import { DAILY_SPIN_ABI } from "@/network/abi/daily-spin";
import { occurredToday } from "@/utils";

export const useDailySpinOnchain = () => {
  const { address } = useAppKitAccount();
  const {
    data,
    isLoading: isLoadingDailySpinStats,
    error,
    refetch,
  } = useReadContract({
    address: import.meta.env.VITE_DAILY_SPIN_CONTRACT_ADDRESS,
    abi: DAILY_SPIN_ABI,
    chainId: dailySpinChainId,
    functionName: "getUserData",
    args: [address as Address],
    query: {
      refetchOnMount: true,
    },
  });
  const { data: spinPrice } = useReadContract({
    address: import.meta.env.VITE_DAILY_SPIN_CONTRACT_ADDRESS,
    abi: DAILY_SPIN_ABI,
    chainId: dailySpinChainId,
    functionName: "getSpinPrice",
    query: {
      refetchOnMount: true,
    },
  });

  const [
    dailySpinStreak,
    lastSpunAtTimestampSeconds,
    jackpotsWon,
    raffleTicketsWon,
    raffleTicketsBalance,
    xpWon,
    plumeTokensWon,
  ] = data?.map(Number) ?? [0, 0, 0, 0, 0, 0, 0];
  const lastSpunAtTimestampMs =
    Number(lastSpunAtTimestampSeconds ?? 0) * MS_IN_SECOND;
  return {
    dailySpinStreak,
    lastSpunAtTimestamp: lastSpunAtTimestampMs,
    jackpotsWon,
    raffleTicketsWon,
    raffleTicketsBalance,
    xpWon,
    plumeTokensWon,
    hasSpunToday: occurredToday(new Date(lastSpunAtTimestampMs)),
    isLoadingDailySpinStats,
    error,
    refetchDailySpinStats: refetch,
    spinPrice,
  };
};
